<template>
    <div
        class="contractStatus"
        :class="status.color"
        :title="status.title"
    ></div>
</template>

<script>
export default {
    props: {
        status: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.contractStatus {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 2px;
}
.contractStatus.green {
    background-color: #4daf51;
}
.contractStatus.yellow {
    background-color: #ffc108;
}
.contractStatus.red {
    background-color: #f44437;
}
.contractStatus.blue {
    background-color: #1284c1;
}
</style>
